import React from 'react';
import GenericSearchForm from '../GenericSearch/GenericSearchForm';

const GuestPermitsSearchForm = (props) => {
  const fields = [
    {
      key: 'unit_number',
      label: 'Unit #',
      placeholder: 'Unit#',
      type: 'text',
      gridProps: { xs: 12, sm: 4, lg: 3, xl: 2 }
    },
    {
      key: 'license_plate',
      label: 'License Plate (LP)',
      placeholder: 'License Plate(LP)',
      type: 'text',
      gridProps: { xs: 12, sm: 4, lg: 3, xl: 2 }
    }
  ];

  return <GenericSearchForm {...props} fields={fields} />;
};

export default GuestPermitsSearchForm;